<template>
  <div class="order-list-item app-bg" :class="{nopay:order.status === 0}" v-if="order">
    <v-layout class="item-header" justify-space-between>
      <span class="time">{{ time }}</span>
      <span class="invoice-status" v-if="order.invoiceStatus==2">开票中</span>
      <span>{{ status }}</span>
    </v-layout>
    <v-layout class="item-content" justify-space-between>
      <v-flex>
        <table class="item-table">
          <tr>
            <td class="td-key">险种</td>
            <td class="td-value">{{ order.productName }}</td>
            <td class="td-key">
              <span v-if="order.status === 1">保单号</span>
            </td>
            <td class="td-value">
              <span v-if="order.status === 1">{{ order.policyNo }}</span>
            </td>
          </tr>
          <tr>
            <td class="td-key">企业名称</td>
            <td class="td-value">{{ order.applicantName }}</td>
            <td class="td-key">保费</td>
            <td class="td-value">￥{{ order.amounts }}</td>
          </tr>
        </table>
      </v-flex>
      <v-flex shrink>
        <v-layout align-center fill-height>
          <v-btn color="primary" class="item-btn" v-if="order.status === 0&&order.payType == 0" @click="toPay">继续支付</v-btn>
          <v-btn color="primary" class="item-btn" v-if="order.payStatus === 0&&order.payType == 1&&order.status!=5" @click="toPay">上传凭证</v-btn>
          <v-btn color="primary" class="item-btn" v-if="order.status === 0&&aigArr.indexOf(Number(order.productId))
          != -1" @click="cancelOrder">撤单</v-btn>
          <v-btn color="primary" class="item-btn" v-if="(order.payType == 1&&order.payStatus == 1)||(order.status == 1&&order.payType == 1)" @click="sampleVisible = true">查看凭证</v-btn>
          <v-btn color="primary" class="item-btn" v-if="order.status === 1&&aigArr.indexOf(Number(order.productId))
          != -1" @click="saveApply(order.orderCode,order.productId)">保全申请</v-btn>
          <v-btn color="primary" class="item-btn" v-if="order.status === 1&&aigArr.indexOf(Number(order.productId))
          != -1&&order.invoiceStatus!=2" @click="downInvoice">{{order.invoiceStatus==1?'查看发票':'开具发票'}}</v-btn>
          <v-btn color="primary" class="item-btn" v-if="order.status === 1&&aigArr.indexOf(Number(order.productId))
          != -1" :loading="insureLoading" @click="orderDown">保单下载</v-btn>
          <v-btn color="primary" class="item-btn" @click="toDetail(order.orderCode,order.productId)">保单详情</v-btn>
          <!-- <v-btn :to="`/order/detail/${order.orderCode}`" class="item-btn" outline>保单详情</v-btn> -->
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="sampleVisible" width="500">
    <p style="text-align:center;color:#fff" v-if="!order.paymentVoucherUrl">凭证加载失败</p>
    <v-card v-else>
      <v-img :src="order.paymentVoucherUrl"></v-img>
    </v-card>
  </v-dialog>
    <v-dialog v-model="visible" persistent max-width="480px" >
        <v-form ref="invoiceForm" lazy-validation class="invoice" v-if="form.invoiceType == 0">
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>发票类型</label>
            <v-select
                v-model="form.invoiceType"
                :items="typelist"
                placeholder="请选择发票类型"
                :solo="solo"
                label
            ></v-select>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>企业名称</label>
            <v-text-field
                v-model="form.billHead"
                :rules="rules.billHead"
                placeholder="请输入企业名称"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>纳税人识别号</label>
            <v-text-field
                v-model="form.billNo"
                :rules="rules.billNo"
                :disabled="true"
                placeholder="请输入纳税人识别号"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>email</label>
            <v-text-field
                v-model="form.email"
                :rules="rules.email"
                placeholder="请输入email"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
            <p class="introduce-text invoice-status" style="text-align: center">开票金额：{{ form.invoicePrice }}</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px;margin-bottom: 4px">纸质专票在保单生效后于7-14 个工作日内寄送，小规模纳税人不能申请专票</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px">特别提示：单次申请的发票合计开票金额低于500 元的，使用到付方式邮寄</p>
        <div style="text-align:center">
            <v-btn color="primary" :loading="invoiceLoading" @click="makeInvoice">确认开票</v-btn>
            <v-btn color="primary" @click="visible = false">关闭</v-btn>
        </div>
        </v-form>
        <v-form ref="paperForm" lazy-validation class="invoice" v-if="form.invoiceType == 1">
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>发票类型</label>
            <v-select
                v-model="form.invoiceType"
                :items="typelist"
                :disabled="editSync"
                placeholder="请选择发票类型"
                :solo="solo"
                label
            ></v-select>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>企业名称</label>
            <v-text-field
                v-model="form.billHead"
                :rules="rules.billHead"
                placeholder="请输入企业名称"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>纳税人识别号</label>
            <v-text-field
                v-model="form.billNo"
                :rules="rules.billNo"
                :disabled="true"
                placeholder="请输入纳税人识别号"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>地址</label>
            <v-text-field
                v-model="paperForm.address"
                :rules="rules.address"
                :disabled="editSync"
                placeholder="请输入地址"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>电话</label>
            <v-text-field
                v-model="paperForm.phone"
                :rules="rules.phone"
                placeholder="请输入电话"
                :disabled="editSync"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>开户行</label>
            <v-text-field
                v-model="paperForm.bankName"
                :rules="rules.bankName"
                :disabled="editSync"
                placeholder="请输入开户行"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>账户</label>
            <v-text-field
                v-model="paperForm.bankNo"
                :rules="rules.bankNo"
                :disabled="editSync"
                placeholder="请输入账户"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>收件公司名称</label>
            <v-text-field
                v-model="paperForm.companyName"
                :rules="rules.companyName"
                :disabled="editSync"
                placeholder="请输入收件公司名称"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>快递地址</label>
            <v-text-field
                v-model="paperForm.mailAddress"
                :rules="rules.mailAddress"
                placeholder="请输入快递地址"
                :disabled="editSync"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>联系电话</label>
            <v-text-field
                v-model="paperForm.contactPhone"
                :disabled="editSync"
                :rules="rules.contactPhone"
                placeholder="请输入联系电话"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>联系人姓名</label>
            <v-text-field
                v-model="paperForm.contactName"
                :disabled="editSync"
                :rules="rules.contactName"
                placeholder="请输入联系人姓名"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
            <p class="introduce-text invoice-status" style="text-align: center">开票金额：{{ form.invoicePrice }}</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px;margin-bottom: 4px">纸质专票在保单生效后于7-14 个工作日内寄送，小规模纳税人不能申请专票</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px">特别提示：单次申请的发票合计开票金额低于500 元的，使用到付方式邮寄</p>
        <div style="text-align:center">
            <v-btn color="primary" v-if="!editSync" :loading="invoiceLoading" @click="makeInvoice">确认开票</v-btn>
            <v-btn color="primary" @click="visible = false">关闭</v-btn>
        </div>
        </v-form>
    </v-dialog>

    <v-dialog v-model="cancerlSync" max-width="290">
      <v-card>
        <v-card-title class="headline">提示</v-card-title>
        <v-card-text> 是否撤销当前订单？ </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat="flat"
            @click="sureCancel"
          >确定</v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="cancerlSync = false"
          >取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <!--支付前确认-->
      <CompanyAccountDetail
              v-if="order.status == 0"
              v-model="payConfirm"
              :companyName="order.applicantName"
              :orderCode="order.orderCode"
              :isContinue="true"
              :policySaveObj="order"
              policyType="policy"
              @submitCompany="toThirdPay2016"
      />
  </div>
</template>

<script>
import validate from "@/assets/js/validate";
import CompanyAccountDetail from "../../insure/components/CompanyAccountDetail";
export default {
    components: {CompanyAccountDetail},
    props: {
    order: Object
  },
  data() {
    return {
      sampleVisible:false,
      cancerlSync:false,
      insureLoading:false,
      invoiceLoading:false,
      solo:true,
      visible:false,
      form:{
        invoiceType:'0',
        enterpriseFlag:'1',
        appPhone:'',
        billHead:"",
        billNo:'',
        companyCode:'',
        email:'',
        policyCode:'',
        orderCode:"",
        invoicePrice: 0,
        policyNo:""
      },
      paperForm:{
        address:"",
        phone:"",
        bankName:"",
        bankNo:"",
        companyName:"",
        mailAddress:"",
        contactPhone:"",
        contactName:"",
      },
      typelist:[{text:'电子发票',value:'0'},{text:'纸质增值税专用发票',value:'1'}],
      rules: {
        billHead: [(v) => !!v || "请输入企业名称"],
        billNo: [(v) => !!v || "请输入纳税人识别号"],
        // appPhone: [(v) => !!v || "请输入联系人电话"],
        address:[(v)=>!!v||"请输入地址"],
        phone:[
           v => {
            if (!v) {
              return "请输入联系电话";
            }
            if (!validate.isTelephone(v) && !validate.isMobilePhone(v)) {
              return "请输入正确的联系电话";
            }
            return true;
          }
        ],
        bankName:[(v)=>!!v||"请输入开户行"],
        bankNo:[(v)=>!!v||"请输入银行卡号"],
        companyName:[(v)=>!!v||"请输入公司名称"],
        mailAddress:[(v)=>!!v||"请输入快递地址"],
        contactPhone:[
           v => {
            if (!v) {
              return "请输入联系电话";
            }
            if (!validate.isTelephone(v) && !validate.isMobilePhone(v)) {
              return "请输入正确的联系电话";
            }
            return true;
          }
        ],
        contactName:[(v)=>!!v||"请输入联系人"],
        email: [(v) => !!v || "请输入email"],
      },
      // order: {
      //   submitTime: "2019年1月16日 18:30",
      //   status: "已出单",
      //   seriesName: "诚泰团体意外伤害保险",
      //   policyNo: "2397511849258930",
      //   applicantName: "北京皇家测试公司",
      //   amounts: "￥2187.00"
      // }
        payConfirm : false,
        aigArr: [2016, 2017]
    };
  },
  computed: {
    time() {
      if (this.order.submitTime) {
        return this.$miment(this.order.submitTime).format("YYYY年MM月DD日 hh:mm");
      }
      return "xxxx年xx月xx日 xx:xx";
    },
    status() {
      if (this.order.status === 1) {
        return "已出单";
      } else if (this.order.status === 0) {
        if(this.order.payStatus == 0){
          return "待支付";
        }else if(this.order.payStatus == 1){
          return "支付中";
        }else if(this.order.payStatus == 2){
          return "已支付";
        }else{
          return "支付失败";
        }
      } else if(this.order.status === 5){
        return "已失效";
      }
      return "未知";
    }
  },
  methods: {
    saveApply(orderCode,productId){
      this.$router.push({
        path:'/order/insureApply/'+orderCode,
        query:{
          productId:productId
        }
      })
    },
    cancelOrder(){
      this.cancerlSync = true;
    },
    sureCancel(){
      //撤单
      this.$axios.get('/app/api/heshunbao/cancelPolicy?orderCode='+this.order.orderCode).then(res=>{
        this.$message.success(res.message);
        this.$router.go(0);
        this.cancerlSync = false;
      })
    },
    toDetail(orderCode,productId){
      this.$router.push({
        path:'/order/detail/'+orderCode,
        query:{
          productId:productId
        }
      });
    },
    toPay() {
      if(this.aigArr.indexOf(Number(this.order.productId))){
        if(this.order.payType == 1){
          this.$router.push({
            path:'/insure/downPay',
            query:{
              param:window.btoa(JSON.stringify({amount:this.order.amounts,orderCode:this.order.orderCode}))
            }
          })
        }else{
            this.payConfirm = true;
        }
      }else{
        const orderCode = this.order.orderCode;
        this.$router.push({ name: "tkpay", params: { orderCode } });
      }
    },
      toThirdPay2016(){
          window.location.href = this.order.thirdPayUrl
      },
    downInvoice(){
      this.editSync = false;
      if(this.order.invoiceStatus==1){
        if(this.order.invoiceUrl){
          window.open(this.order.invoiceUrl)
        }else{
          this.form.invoiceType = '1'
          this.visible = true;
          this.editSync = true;
          this.$axios.get('/app/api/heshunbao/invoiceInfo?orderCode='+this.order.orderCode).then(res=>{
            this.form.billHead = res.data.billHead;
            this.form.billNo = res.data.billNo;
            this.form.email = res.data.email;
            this.form.invoicePrice = res.data.invoicePrice;
            this.form.policyNo = res.data.policyNo;
            this.paperForm.address = res.data.address;
            this.paperForm.phone = res.data.phone;
            this.paperForm.bankName = res.data.bankName;
            this.paperForm.bankNo = res.data.bankNo;
            this.paperForm.companyName = res.data.companyName;
            this.paperForm.mailAddress = res.data.mailAddress;
            this.paperForm.contactPhone = res.data.contactPhone;
            this.paperForm.contactName = res.data.contactName;
          })
        }
      }else{
        this.visible = true;
        this.$axios.get('/app/api/heshunbao/invoiceInfo?orderCode='+this.order.orderCode).then(res=>{
          this.form.billHead = res.data.billHead;
          this.form.billNo = res.data.billNo;
          this.form.email = res.data.email;
          this.form.invoicePrice = res.data.invoicePrice;
          this.form.policyNo = res.data.policyNo;
        })
      }
    },
    orderDown(){
      this.insureLoading = true
      const elink = document.createElement("a");
      elink.style.display = "none";
      elink.href = process.env.VUE_APP_API_URL+'/app/api/heshunbao/downloadPolicy?orderCode='+this.order.orderCode;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      this.$axios.get('/app/api/heshunbao/downloadPolicy?orderCode='+this.order.orderCode).then(()=>{
          this.insureLoading = false
      }).catch(()=>{
          this.insureLoading = false
      })
    },
    makeInvoice(){
      if(this.form.invoiceType == 0){
        if (this.$refs.invoiceForm.validate()) {
          this.invoiceLoading = true
          this.$axios.post('/app/api/heshunbao/makeInvoice',this.form).then(res=>{
              if(res.code == 200){
                this.$emit('update',true)
                if(res.data.invoiceUrl){
                  window.open(res.data.invoiceUrl)
                  this.visible = false
                }else{
                  this.$message.success(res.data.message)
                  this.visible = false
                }
              }
              this.invoiceLoading = false
          }).catch((val)=>{
              this.$message.error(val.message)
              this.invoiceLoading = false
          })
        }
      }else{
        if (this.$refs.paperForm.validate()) {
          this.invoiceLoading = true
          const {billHead,billNo,invoicePrice,policyNo} = this.form
          let param = {
            billHead,
            billNo,
            invoicePrice,
            policyNo,
            ...this.paperForm
          }
          this.paperForm
           this.$axios.post('/app/api/heshunbao/makeSpecialInvoice',param).then(res=>{
              if(res.code == 200){
                this.$emit('update',true)
                this.visible = false
                this.$message.success(res.message)
              }
              this.invoiceLoading = false
          }).catch((val)=>{
              this.$message.error(val.message)
              this.invoiceLoading = false
          })
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
$nopay-color: #fb7282;
.invoice-status{
  color: $primary-color;
}
.invoice{
    background-color: #fff;
    padding: 30px;
    .form-item{
        label{
            width: 100px;
        }
    }
}
.must-tap {
          color: red;
          margin-right: 3px;
        }
.order-list-item {
  margin-top: 20px;
  border: 1px solid #cccccc;
  font-size: 14px;
  &.nopay {
    border-color: $nopay-color;
    .item-header {
      background-color: #fffafb;
      border-bottom: 1px solid $nopay-color;
    }
  }
  .item-header {
    padding: 18px 30px;
    background-color: #fcfcfc;
    border-bottom: 1px solid #cccccc;
    .time {
      color: #666666;
    }
  }
  .item-content {
    padding: 14px 30px;
    .item-btn {
      border: 0.5px solid #979797;
      width: 110px;
      height: 34px;
    }
    .item-table {
      .td-key {
        color: $font-color3;
      }
      .td-value {
        padding: 2px 40px 2px 15px;
      }
    }
  }
}
</style>

